import React, {useContext, useState} from 'react';
import GenericDialog from '@common/GenericDialog';
import { Form, Radio } from 'antd';
import { BrandContext } from '@context/BrandContext';
import { HelpIcon } from '@common/icons';
import TooltipMUI from '@mui/material/Tooltip';

const helpTooltipContent = 'An online exam can only use multiple choice<br/>questions that can be auto-marked by the platform.<br/>A print exam can include Short answer and<br/>Extended response type of questions.';

const CreateTestDialog = ({ open, onClose, onWizardCreateTest, onCreateTest, hasExams = false }) => {
    const brandConfig = useContext(BrandContext),
        [createButtonDisabled, setCreateButtonDisabled] = useState(false),
        [printTypeDisabled, setPrintTypeDisabled] = useState(true),
        [wizardDisabled, setWizardDisabled] = useState(false),
        [createTestForm] = Form.useForm();

    const handleCreateTest = () => {
        return new Promise((resolve, reject) => {
            const { testType, testCreationType, assessmentType } = createTestForm.getFieldsValue();

            try {
                if (testType === 'EXAM') {
                    if (testCreationType === 'WIZARD') {
                        onWizardCreateTest();
                    } else {
                        onCreateTest({
                            autoMark: assessmentType === 'ONLINE',
                            testPurpose: testType
                        });
                    }
                } else {
                    if (testCreationType === 'WIZARD') {
                        onWizardCreateTest();
                    } else {
                        onCreateTest();
                    }
                }
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    };

    const handleFormChange = (_, allValues) => {
        const { testType } = allValues;

        if(testType !== undefined){
            if (testType === 'TEST') {
                setPrintTypeDisabled(true);
                setWizardDisabled(false);
            } else {
                setPrintTypeDisabled(false);
                setWizardDisabled(true);
                createTestForm.setFieldValue('testCreationType', 'MANUAL_SELECTION');
            }
        }
    };

    return (
        <GenericDialog
            fullWidth={true}
            maxWidth={'xs'}
            title={`Create ${brandConfig.testName}`}
            open={open}
            onClose={onClose}
            style={{margin: 0}}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                },
                {
                    name: 'Create',
                    disabled: createButtonDisabled,
                    callback: handleCreateTest
                },
            ]}
        >
            <Form
                form={createTestForm}
                layout="vertical"
                className="flexColumn mediumGap"
                initialValues={{
                    testType: brandConfig.hasTests || !hasExams ? 'TEST' : 'EXAM',
                    testCreationType: 'WIZARD',
                    assessmentType: 'ONLINE',
                }}
                onValuesChange={handleFormChange}
            >
                {hasExams && (
                    <Form.Item name="testType" label="Create">
                        <Radio.Group
                            optionType="button"
                            buttonStyle={'solid'}
                            options={[
                                { label: 'Test', value: 'TEST', disabled: !brandConfig.hasTests },
                                { label: 'Exam', value: 'EXAM' },
                            ]}
                        />
                    </Form.Item>
                )}

                <Form.Item name="testCreationType" label={'Create ' + brandConfig.testName.toLowerCase() + ' using:'}>
                    <Radio.Group
                        buttonStyle={'solid'}
                        optionType="button"
                        options={[
                            { label: 'Wizard', value: 'WIZARD', disabled: wizardDisabled },
                            { label: 'Manual selection', style:{whiteSpace:'nowrap'}, value: 'MANUAL_SELECTION' },
                        ]}
                    />
                </Form.Item>

                {hasExams && (
                    <Form.Item
                        name="assessmentType"
                        className="ch-pointer-events"
                        label={
                            <div className="flex smallGap">
                                <span>Exam type</span>
                                <TooltipMUI
                                    tabIndex={0}
                                    placement="top"
                                    title={
                                        <div
                                            className="ch-med-font"
                                            dangerouslySetInnerHTML={{ __html: helpTooltipContent }}
                                        />
                                    }
                                >
                                  <span>
                                    <HelpIcon style={{ verticalAlign: 'middle', width: '20px', height: '20px' }} />
                                  </span>
                                </TooltipMUI>
                            </div>
                        }
                    >
                        <Radio.Group
                            disabled={printTypeDisabled}
                            buttonStyle={'solid'}
                            optionType="button"
                            options={[
                                { label: 'Online', value: 'ONLINE' },
                                { label: 'PDF/Word', value: 'PDF_WORD' },
                            ]}
                        />
                    </Form.Item>
                )}
            </Form>
        </GenericDialog>
    );
};

export default CreateTestDialog;
